const fr = {
  nav: {
    studio: "Studio",
    servizi: "Services",
    portfolio: "Portfolio",
    team: "Équipe",
    journal: "Journal",
    studioTagline: "Studio numérique",
    contatti: "Contact",
    parliamone: "Discutons",
  },
  common: {
    iniziamoProgetto: "Démarrer un projet",
    scriviStudio: "Écrire au studio",
    vediServizi: "Tous les services",
    conosciStudio: "Découvrir le studio",
    scopriDiPiu: "En savoir plus",
  },
  footer: {
    overline: "Studio · 2026",
    headline1: "Nous fabriquons",
    headlineEditorial: "des expériences",
    headline2: "numériques sur mesure.",
    navHeading: "Naviguer",
    writeHeading: "Écrivez-nous",
    tagline:
      "Modélisation 3D · Prototypage · Environnements numériques · Direction créative.",
    rights: "Tous droits réservés",
    madeWith: "Made with quiet obsession",
  },
  home: {
    hero: {
      overline: "Studio numérique · Fondé par Riccardo et Sasha",
      title1: "Nous donnons",
      titleEditorial: "forme",
      title2: "à votre",
      title3: "imaginaire.",
      paragraph:
        "Mysterious Stew est un studio de deux personnes qui allie modélisation 3D, prototypage et environnements numériques en un seul atelier créatif — avec un réseau de collaborateurs externes pour chaque besoin.",
      cta1: "Démarrer un projet",
      cta2: "Ce que nous faisons",
    },
    marquee: [
      "Modélisation 3D",
      "Rendering",
      "Prototypage",
      "Optimisation STL",
      "Environnements numériques",
      "Direction créative",
      "Print-ready",
      "Motion",
    ],
    services: {
      overline: "Services · Quatre disciplines",
      title1: "Un seul studio,",
      titleEditorial: "quatre matières",
      title2: "à composer.",
      paragraph:
        "Chaque projet est traité comme une pièce unique. Nous choisissons les compétences justes — internes ou de nos collaborateurs — pour obtenir le résultat le plus précis.",
      items: [
        {
          title: "Modélisation 3D",
          desc: "Sculpting hard-surface et organique. Assets prêts pour le rendu, le cinéma, le jeu ou l'impression.",
        },
        {
          title: "Prototypage & impression 3D",
          desc: "Du fichier à la pièce tangible. Prototypes, masters de production, éditions limitées.",
        },
        {
          title: "Environnements numériques",
          desc: "Sets virtuels, espaces immersifs, scènes photoréalistes pour storytelling et produit.",
        },
        {
          title: "Support numérique",
          desc: "Direction créative continue : conseil, workflow, production de contenus et coordination.",
        },
      ],
    },
    studio: {
      overline: "Le studio · Deux fondateurs",
      titleRiccardo: "Riccardo",
      titleAmp: "&",
      titleSasha: "Sasha.",
      titleLine2: "Un core team,",
      titleLine3: "un réseau étendu.",
      paragraph:
        "Nous sommes deux, mais nous ne travaillons pas seuls. Nous composons la bonne équipe pour chaque projet en activant illustrateurs, animateurs, sculpteurs et développeurs avec qui nous collaborons depuis des années.",
      role: "Cofondateur",
    },
    finalCta: {
      overline: "Prochaine étape",
      title1: "Une idée ?",
      titleEditorial: "Cuisinons-la ensemble.",
      button: "Écrire au studio",
    },
  },
  services: {
    header: {
      overline: "Services",
      title1: "Quatre disciplines,",
      titleEditorial: "un langage commun",
      titleEnd: ".",
      paragraph:
        "Nous ne proposons pas de pack préemballés. Chaque projet est traversé — ensemble — du premier croquis à la livraison finale, en activant les bonnes compétences au bon moment.",
    },
    items: [
      {
        tag: "3D",
        title: "Modélisation 3D",
        desc: "Sculpting hard-surface et organique, modélisation low-poly et high-poly. Assets prêts pour rendus photoréalistes, cinéma, jeux vidéo ou impression 3D.",
        deliverables: [
          "Modèles STL / OBJ / FBX",
          "Retopology & UV",
          "Concept-to-model itératif",
          "Masters de production",
        ],
      },
      {
        tag: "PRINT",
        title: "Prototypage & impression 3D",
        desc: "Du fichier à la pièce tangible. Préparation des supports, optimisation résine/FDM, prototypes fonctionnels et séries limitées.",
        deliverables: [
          "Fichiers print-ready",
          "Supports & orientation",
          "Prototypes fonctionnels",
          "Éditions limitées",
        ],
      },
      {
        tag: "ENV",
        title: "Environnements numériques",
        desc: "Sets virtuels, espaces immersifs, scènes photoréalistes ou stylisées pour storytelling, présentation produit, expériences interactives.",
        deliverables: [
          "Scènes photoréalistes",
          "Sets virtuels",
          "Previews temps réel",
          "Séquences animées",
        ],
      },
      {
        tag: "STUDIO",
        title: "Support numérique",
        desc: "Direction créative continue : conseil, définition de workflow, production de contenus et coordination avec des collaborateurs externes.",
        deliverables: [
          "Direction créative",
          "Production de contenus",
          "Workflow design",
          "Équipe à la demande",
        ],
      },
    ],
    cta: {
      overline: "Un brief hybride ?",
      title1: "Les meilleurs projets",
      title2: "naissent à la",
      titleEditorial: "frontière",
      titleEnd: ".",
      button: "Parlez-nous de votre projet",
    },
  },
  team: {
    intro: {
      overline: "Le studio",
      title1: "Deux mains",
      titleEditorial: "beaucoup de voix",
      titleEnd: ".",
      paragraph:
        "Le core team est composé de deux personnes. Autour de nous gravite un réseau stable de collaborateurs externes — illustrateurs, animateurs, sculpteurs, développeurs — qui nous permet de composer la bonne équipe pour chaque projet sans jamais perdre en cohérence.",
    },
    founders: [
      {
        name: "Riccardo",
        role: "Cofondateur · Sculpture numérique & direction créative",
        badge: "Cofondateur 01",
        bio: "Modèle figures, silhouettes et poses. Guide l'esthétique visuelle du studio et donne voix au côté plus tactile et matériel de notre travail.",
        focus: ["Sculpting", "Character design", "Art direction"],
      },
      {
        name: "Sasha",
        role: "Cofondateur · Hard-surface & workflow technique",
        badge: "Cofondateur 02",
        bio: "S'occupe de la partie technique : hard-surface, retopology, printability et l'architecture de nos flux de travail end-to-end.",
        focus: ["Hard-surface", "Printability", "Tech pipeline"],
      },
    ],
    crew: {
      overline: "Le réseau étendu",
      title1: "Une équipe qui se",
      titleEditorial: "compose",
      title2: "autour du projet.",
      paragraph:
        "Nous ne sommes pas une agence avec des départements figés. Nous activons les bons profils au cas par cas — nous deux restant la constante qui garantit direction, qualité et continuité.",
      items: [
        { role: "Illustrateurs", count: "02", desc: "Concept et développement visuel." },
        { role: "Animateurs", count: "02", desc: "Motion et séquences animées." },
        { role: "Sculpteurs", count: "03", desc: "Finitions et pièces spéciales." },
        { role: "Développeurs", count: "02", desc: "Backend et intégrations web." },
      ],
    },
    manifesto: {
      overline: "Notre façon",
      quote:
        "\u00AB Nous préférons livrer quelques projets faits avec une attention obsessionnelle, plutôt que beaucoup faits à la hâte. \u00BB",
      button: "Travailler avec nous",
    },
  },
  portfolio: {
    header: {
      overline: "Portfolio · Sélection",
      title1: "Des projets,",
      titleEditorial: "pas des produits",
      titleEnd: ".",
      paragraph:
        "Une sélection des collaborations récentes du studio — modélisation, environnements numériques et prototypes pour l'impression 3D.",
    },
    projects: [
      {
        id: "obsidian-vault",
        title: "Obsidian Vault",
        tag: "Environnement numérique",
        desc: "Environnement immersif pour le lancement d'un produit de luxe : modélisation, lighting et post-production.",
      },
      {
        id: "forma-01",
        title: "Forma 01",
        tag: "Modélisation 3D",
        desc: "Série de sculptures numériques abstraites pour une collection limitée.",
      },
      {
        id: "corpo-solido",
        title: "Corpo Solido",
        tag: "Prototypage",
        desc: "Prototypage rapide d'un composant mécanique. Itération du fichier à la pièce finie.",
      },
      {
        id: "vitrea",
        title: "Vitrea",
        tag: "Environnement numérique",
        desc: "Set virtuel pour une campagne éditoriale de marque d'accessoires.",
      },
      {
        id: "atelier-site",
        title: "Atelier — site éditorial",
        tag: "Site web",
        desc: "Site sur mesure pour un studio d'art contemporain. Design, développement et CMS.",
      },
      {
        id: "collettivo",
        title: "Collettivo",
        tag: "Support créatif",
        desc: "Conseil continu pour un collectif d'artistes : workflow et production de contenus.",
      },
    ],
    cta: {
      overline: "Un projet similaire ?",
      title1: "Chaque projet a",
      title2: "sa",
      titleEditorial: "juste question",
      titleEnd: ".",
      button: "Commençons la conversation",
    },
  },
  journal: {
    header: {
      overline: "Journal · Notes du studio",
      title1: "Notes,",
      titleEditorial: "pas des tutoriels",
      titleEnd: ".",
      paragraph:
        "Pensées, coulisses et réflexions sur le métier. Nous mettons à jour le journal quand nous avons quelque chose qui vaut la peine d'être écrit — jamais pour remplir un calendrier.",
    },
    tags: [
      "3D",
      "Modélisation",
      "Print",
      "Notes de studio",
      "Workflow",
      "Direction créative",
      "Environnements",
      "Collaborations",
    ],
    readTimeLabel: "Lecture",
    readTimeUnit: "min",
    backLabel: "Retour au journal",
    moreLabel: "Autres notes",
    entries: [
      {
        slug: "superficie-e-luce",
        date: "12 · 02 · 2026",
        tag: "Note de studio",
        title: "Comment nous pensons la modélisation 3D de luxe",
        excerpt:
          "Une note interne devenue publique : pourquoi notre obsession pour la surface a beaucoup moins à voir avec le brillant qu'avec la lumière.",
        readTime: "6",
        intro:
          "Cette note est née d'une conversation interne au studio, devant un rendu qui ne nous convainquait pas. Le modèle était techniquement impeccable, et pourtant il paraissait… bon marché. De là est partie une réflexion sur ce qui rend vraiment « luxueux » un objet numérique.",
        sections: [
          {
            h: "La surface n'est pas du polissage",
            p: "Quand on parle de modélisation haut de gamme, l'instinct pousse à ajouter : plus de polygones, plus de reflets, plus de détails. Nous avons appris à faire l'inverse. Une surface de luxe est une surface contrôlée — courbures continues, transitions propres, aucune imperfection accidentelle. Le détail n'existe que là où il est nécessaire, et chaque chanfrein a un rayon pensé.",
          },
          {
            h: "C'est la lumière qui raconte la forme",
            p: "Un modèle se juge en déplaçant une lumière sur sa surface. Si les reflets glissent sans rupture, la forme est résolue ; s'ils se brisent, aucun matériau ne pourra la sauver. C'est pourquoi nous passons plus de temps sur les courbures que sur les textures : la perception de qualité naît là, bien avant le rendu final.",
          },
          {
            h: "Ce que cela change pour nos clients",
            p: "Cela signifie que nos devis contiennent une ligne invisible : le temps consacré à ce qui ne se voit pas au premier regard mais se perçoit toujours. C'est la différence entre un objet numérique qui « fonctionne » et un objet qui semble vrai, précieux, désirable. C'est la raison pour laquelle nos clients reviennent.",
          },
        ],
      },
      {
        slug: "anatomia-prototipo",
        date: "24 · 01 · 2026",
        tag: "Workflow",
        title: "Du croquis à l'impression — anatomie d'un prototype",
        excerpt:
          "Nous revenons sur un projet récent pour raconter comment nous unissons modélisation, retopology et impression 3D quand chaque millimètre compte.",
        readTime: "9",
        intro:
          "Un composant mécanique, des tolérances serrées et un client avec une vraie échéance. Nous retraçons les étapes d'un projet récent pour montrer comment nous travaillons quand un fichier doit devenir un objet physique.",
        sections: [
          {
            h: "Le premier croquis est déjà de l'ingénierie",
            p: "Chaque prototype commence sur le papier, mais avec des contraintes claires dès le premier trait : dimensions réelles, points de contrainte, orientation d'impression. Dessiner sans penser à la production, c'est devoir redessiner ensuite. Dans notre flux, forme et faisabilité naissent ensemble.",
          },
          {
            h: "Retopology : là où se gagnent les millimètres",
            p: "Le passage du modèle sculpté à la mesh de production est la phase la plus silencieuse et la plus critique. Épaisseurs minimales garanties, géométries fermées, surfaces vérifiées. Sasha contrôle chaque zone critique avec des sections transversales : quand une pièce doit s'emboîter dans une autre, la marge d'erreur est nulle.",
          },
          {
            h: "L'impression est une vérification, pas une ligne d'arrivée",
            p: "La première pièce imprimée n'est jamais la pièce finale. Elle sert à mesurer, assembler, comprendre où la réalité s'écarte du fichier. Ce projet a demandé trois itérations : la troisième s'emboîtait d'un clic net, sans jeu. Ce son — un clic précis — est le vrai livrable.",
          },
        ],
      },
      {
        slug: "manifesto-pacchetti",
        date: "08 · 01 · 2026",
        tag: "Journal",
        title: "Un petit manifeste contre les packs préemballés",
        excerpt:
          "Chaque projet est un problème différent. Voici pourquoi nous n'offrons pas de listes de prix standards et comment ce choix change la façon de travailler avec nous.",
        readTime: "4",
        intro:
          "On nous demande souvent : « Combien coûte un modèle 3D ? Et un environnement numérique ? ». La réponse honnête : ça dépend. Ce petit manifeste explique pourquoi nous n'avons pas de liste de prix, et pourquoi nous pensons que c'est un avantage pour ceux qui travaillent avec nous.",
        sections: [
          {
            h: "Chaque projet est une question différente",
            p: "Un pack préemballé suppose que tous les problèmes se ressemblent. Notre expérience dit le contraire : la même demande — « un modèle pour l'impression » — peut demander trois jours ou trois semaines selon l'usage, le matériau et le niveau de finition. Chiffrer avant de comprendre, c'est chiffrer mal.",
          },
          {
            h: "Le devis comme premier acte du projet",
            p: "Pour nous, un devis n'est pas un chiffre : c'est la première ébauche du projet. Il contient les phases, les itérations prévues, ce qui est inclus et ce que nous conseillons de reporter. Un client qui lit notre devis sait déjà comment nous travaillerons ensemble, avant même de signer.",
          },
          {
            h: "Moins de projets, mieux faits",
            p: "Refuser la logique des packs nous oblige à choisir : nous ne prenons que les projets auxquels nous pouvons consacrer une attention réelle. C'est un choix commercialement à contre-courant, mais c'est pourquoi chaque travail qui sort du studio porte le même soin, du premier au dernier pixel.",
          },
        ],
      },
      {
        slug: "rete-estesa",
        date: "22 · 12 · 2025",
        tag: "Collaborations",
        title: "Le réseau étendu : qui se cache derrière chaque projet",
        excerpt:
          "Illustrateurs, animateurs, sculpteurs. Les personnes qui gravitent autour du core team et comment elles sont choisies pour chaque commande.",
        readTime: "5",
        intro:
          "Sur le site, nous écrivons « un core team de deux personnes, un réseau étendu de collaborateurs ». Mais qu'est-ce que cela signifie en pratique ? Qui touche vraiment vos projets, et comment choisissons-nous nos collaborateurs ?",
        sections: [
          {
            h: "Deux personnes comme point fixe",
            p: "Riccardo et Sasha suivent chaque projet du début à la fin : direction créative, relation client, contrôle qualité. Rien ne sort du studio sans passer entre nos mains. Cela garantit la cohérence — le même standard, la même voix, sur chaque livraison.",
          },
          {
            h: "Comment nous choisissons nos collaborateurs",
            p: "Le réseau étendu n'est pas une liste de freelances trouvés au besoin : ce sont des professionnels avec qui nous travaillons depuis des années — illustrateurs, animateurs, sculpteurs, développeurs. Chacun a été choisi après de vrais projets, pas des entretiens. Si un nom figure dans notre réseau, c'est qu'il a déjà prouvé qu'il tient notre standard.",
          },
          {
            h: "L'avantage pour le client",
            p: "Ce modèle combine le meilleur de deux mondes : le soin et la responsabilité directe d'un petit studio, avec la capacité de production d'une équipe plus grande. Le client parle toujours avec nous deux, mais derrière chaque projet se compose l'équipe exacte que cette commande exige.",
          },
        ],
      },
    ],
    cta: {
      overline: "Restons en contact",
      title1: "Peu de notes,",
      titleEditorial: "quand elles comptent",
      titleEnd: ".",
      button: "Écrivez-nous pour des collaborations",
    },
  },
  contact: {
    header: {
      overline: "Contact",
      title1: "Commençons",
      title2: "à",
      titleEditorial: "en parler",
      titleEnd: ".",
      paragraph:
        "Un projet en tête, une idée à explorer, une question ? Écrivez-nous tranquillement. Riccardo et Sasha répondent personnellement en quelques jours.",
    },
    form: {
      nameLabel: "Nom",
      namePlaceholder: "Comment vous appelez-vous ?",
      emailLabel: "Email",
      emailPlaceholder: "vous@email.com",
      subjectLabel: "Sur quoi travaillons-nous ?",
      messageLabel: "Message",
      messagePlaceholder: "Racontez-nous le projet, l'idée, la deadline…",
      hint: "Nous répondons personnellement, en général sous 3 jours ouvrés.",
      submit: "Envoyer",
      submitting: "Envoi en cours…",
      validationError: "Remplissez nom, email et message.",
      sendError: "Erreur lors de l'envoi. Réessayez plus tard.",
      successToast: "Message envoyé — nous revenons vite vers vous.",
    },
    services: [
      "Modélisation 3D",
      "Prototypage & impression 3D",
      "Environnements numériques",
      "Support numérique",
      "Autre",
    ],
    wizard: {
      stepWord: "Étape",
      ofWord: "sur",
      step1Title: "Sur quoi travaillons-nous ?",
      step2Title: "Quel budget avez-vous en tête ?",
      step2Hint: "Une estimation sert seulement à orienter la proposition — sans engagement.",
      budgetOptions: ["Moins de 500 €", "500 – 1 500 €", "1 500 – 5 000 €", "Plus de 5 000 €", "À définir ensemble"],
      step3Title: "Pour quand en avez-vous besoin ?",
      timelineOptions: ["Urgent (sous 2 semaines)", "Sous 1 mois", "1 – 3 mois", "Flexible"],
      step4Title: "Parlez-nous du projet",
      step5Title: "Vos coordonnées",
      summaryTitle: "Récapitulatif de la demande",
      next: "Suivant",
      back: "Retour",
      selectHint: "Sélectionnez une option pour continuer",
    },
    thanks: {
      overline: "Bien reçu",
      title1: "Merci —",
      titleEditorial: "on revient vite",
      titleEnd: ".",
      paragraph:
        "Votre message est arrivé au studio. Nous répondrons personnellement sous quelques jours ouvrés.",
      again: "Envoyer un autre message",
    },
    info: {
      emailTitle: "Email direct",
      emailNote:
        "Pour les collaborations, demandes d'impression ou devis. Nous répondons personnellement.",
      whereTitle: "Où nous sommes",
      whereValue: "Italie",
      whereNote: "Studio remote · nous travaillons avec des clients en Europe et au-delà.",
      timeTitle: "Délai de réponse",
      timeValue: "3 jours ouvrés",
      timeNote: "Nous répondons à chaque message, un par un.",
    },
  },
  seo: {
    home: {
      title: "Mysterious Stew — Studio digital · 3D, impression et environnements numériques",
      description:
        "Le studio digital de Riccardo et Sasha : modélisation 3D, prototypage et impression 3D, environnements numériques et accompagnement créatif sur mesure.",
    },
    servizi: {
      title: "Services — Modélisation 3D, impression 3D et environnements numériques · Mysterious Stew",
      description:
        "Quatre disciplines, un seul langage : modélisation 3D, prototypage et impression 3D, environnements numériques et support digital continu.",
    },
    team: {
      title: "Le studio — Riccardo & Sasha · Mysterious Stew",
      description:
        "Deux fondateurs, un réseau étendu de collaborateurs : illustrateurs, animateurs, sculpteurs et développeurs réunis autour de chaque projet.",
    },
    journal: {
      title: "Journal — Notes du studio · Mysterious Stew",
      description:
        "Notes, coulisses et réflexions sur le métier : modélisation 3D, workflows d'impression, direction créative.",
    },
    contatti: {
      title: "Contact — Lançons un projet · Mysterious Stew",
      description:
        "Parlez-nous de votre projet : modélisation 3D, prototypage, environnements numériques ou accompagnement créatif. Réponse personnelle sous 3 jours.",
    },
  },
  mmf: {
    views: "Vues",
    likes: "J'aime",
    followers: "Abonnés",
    models: "Modèles publiés",
    visit: "Tout voir sur MyMiniFactory",
    collectionsLabel: "Nos factions",
    viewerLabel: "Aperçu 3D",
    viewerTitle: "Touchez-le",
    viewerTitleEditorial: "du doigt.",
    viewerHint: "Faites glisser pour pivoter",
    viewerLoading: "Chargement du modèle…",
    featuredLabel: "Modèles en vedette",
  },
  language: {
    label: "Langue",
  },
};

export default fr;
